import { CreateUserProfileRequest } from '@core/data-access/models/api/user-profile.model';
import { DownloadTicketType } from '@core/data-access/models/download-ticket.model';

export interface UserModel {
  authToken: string | null;
  id?: number;
  userType?: string;
  email?: string;
}

export interface LoginModel {
  email: string;
  password: string;
}

export type CreateUserProfile = CreateUserProfileRequest &
  Partial<{
    questionnaire: QuestionnaireSaveModel;
  }>;

export interface UserProfileModel {
  userType?: string;
  authToken?: string;
  id?: number;
  gender: string;
  title: string;
  lastName: string;
  firstName: string;
  company: string;
  function: string;
  department: string;
  occupationalGroup: string;
  country: string;
  street: string;
  address?: string;
  zipCode: string;
  telephone: string;
  city: string;
  email: string;
  password?: string;
  provider?: string;
  providerKey?: number;
  newsletterChecked: any;
  fairCatalogChecked: boolean;
  isEmailVerified?: boolean;
  isEmailChangePending?: boolean;
  isPasswordChangePending?: boolean;
  isPhoneVerified?: boolean;
  phoneVerificationRequired?: boolean;
  language?: string;
  eventId?: number;
  dateOfBirth: string;
  questionnaire?: QuestionnaireSaveModel;
  origin?: LoginOrigin;
}

export const enum LoginOrigin {
  Unknown = 'unknown',
  Anonymous = 'anonymous',
  Registration = 'registration',
  Import = 'import',
  LegitimationImport = 'legitimationImport',
  VoucherImport = 'voucherImport',
  Facebook = 'facebook',
  Google = 'google',
  LinkedIn = 'linkedIn',
  X = 'x',
  Vkontakte = 'vkontakte',
  ConteoLogin = 'conteoLogin',
  Microsoft = 'microsoft',
  Apple = 'apple',
  Amazon = 'amazon'
}

export const enum LoginType {
  Registration = 'Registration',
  SocialNetwork = 'SocialNetwork',
  Conteo = 'Conteo'
}

export interface UserProfileUpdateModel extends UserProfileModel {
  title: string;
  lastName: string;
  firstName: string;
  company: string;
  function: string;
  department: string;
  occupationalGroup: string;
  country: string;
  street: string;
  zipCode: string;
  city: string;
  telephone: string;
  newsletterChecked: any;
  fairCatalogChecked: boolean;
  gender: string;
  language: string;
  eventId: number;
  isSelfRegistration: boolean;
  dateOfBirth: string;
}

export interface BillingAddressModel {
  id?: number;
  company: string;
  address: string;
  street: string;
  city: string;
  zipCode: string;
  country: string;
}

export interface EventsEmailUnsubscribeModel {
  id: number;
  eventName: string;
}

export interface RegistrationQuestionnaireModel {
  id: number;
  name: string;
  type: string;
  isMandatory: boolean;
  label: string;
  order: number;
  textLength: number;
  values: RegistrationQuestionnaireDataModel[];
}

export interface RegistrationQuestionnaireDataModel {
  id: number;
  text: string;
  order: number;
}

export interface QuestionnaireSaveModel {
  id?: number;
  eventId: number;
  orderId?: number;
  values: Array<{
    fieldId: number;
    valueId: number;
    text: string;
  }>;
}

export interface QuestionnaireUserSaveModel {
  userId?: number;
  eventId?: number;
  questionnaire: QuestionnaireSaveModel[];
}

export interface VerifyEmailResponseModel {
  statusCode: number;
  body: {
    assignedTickets: number;
    assignedOrders: number;
  };
}

export interface DownloadTicket {
  id: number;
  type: DownloadTicketType;
  ticketId?: number;
  packageIndex?: number;
}
